@if (isVisible()) {
<button (click)="scrollToTop()" class="scroll-to-top-btn" aria-label="Scroll to top">
    <span class="material-icons">arrow_upward</span>
</button>
}